var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTabletArrowLineLearning = function SvgTabletArrowLineLearning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83.55,
    height: 16.07,
    viewBox: "0 0 83.55 16.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-122, .cls-322 {\n        fill: #664cff;\n      }\n\n      .cls-222 {\n        fill: none;\n        stroke: #664cff;\n        stroke-width: 0.92px;\n      }\n\n      .cls-322 {\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n\n      .cls-422 {\n        fill: #eae4ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M5.65,8,0,12.11V4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-222",
    x1: 4.65,
    y1: 8.04,
    x2: 83.55,
    y2: 8.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-322",
    x: 13.68,
    y: 1,
    width: 29.27,
    height: 14.07,
    rx: 3.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-422",
    d: "M24.65,11.13H21.11L24,8.23h0l.93-.92a.62.62,0,0,0,.12-.19.61.61,0,0,0,0-.42.76.76,0,0,0-.12-.19L23.36,4.94a.56.56,0,0,0-.79,0h0L18.34,9.16a.76.76,0,0,0-.12.19h0a.63.63,0,0,0,0,.19v1.59a.59.59,0,0,0,.16.4.56.56,0,0,0,.4.17h5.9a.29.29,0,1,0,0-.57ZM23,5.34l1.58,1.57-.73.73L22.24,6.07Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTabletArrowLineLearning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TabletArrowLineLearning.b19ee24c.svg";
export { ForwardRef as ReactComponent };